import { HTMLTags } from '@/stories/strapi-4/common-types'

export type TGuideData = {
  step?: string
  stepText?: string
  heading: string
  subHeading?: string
  card_data: {
    type: string
    image?: string
    text?: string
    aText?: string
    dataText?: { text: string }[]
  }[]
  image: string
  bgcolor: string
  headingColor: string
  headingType?: HTMLTags
  mainHeading?: string
}[]

export const MFGuideData1: TGuideData = [
  {
    step: 'Step 1',
    stepText: 'Open MF a/c',
    heading: 'Open a Free Mutual Fund Account by Completing Digital KYC',
    headingType: 'p',
    card_data: [
      {
        type: 'text',
        dataText: [
          {
            text: 'Complete your KYC to open your free mutual fund account. Make sure you have the following details handy:',
          },
        ],
      },
      {
        type: 'pointers',
        dataText: [{ text: '1. PAN Number' }, { text: '2. Aadhaar Number' }],
      },
      {
        type: 'text',
        dataText: [
          {
            text: 'KYC on INDmoney is fully digital, paperless, and takes less than 3 minutes to complete.',
          },
        ],
      },
    ],
    image: 'https://indcdn.indmoney.com/cdn/images/fe/how_to_invest_mf_s1.png',
    bgcolor: 'bg-brand-grey-extraLight',
    headingColor: 'text-gray-700',
  },
  {
    step: 'Step 2',
    stepText: 'Select a Mutual Fund',
    heading: 'Select a Mutual Fund',
    headingType: 'p',
    card_data: [
      {
        type: 'text',
        dataText: [
          {
            text: 'Based on your investment goals & risk tolerance, pick the best-suited mutual fund category. You can choose from:',
          },
        ],
      },
      {
        type: 'pointers',
        dataText: [
          {
            text: '• Equity funds: Primarily invest in stocks and are suitable for long-term growth but carry higher risk.',
          },
          {
            text: '• Debt funds: Invest in bonds and fixed-income assets, offering stable but lower returns.',
          },
          {
            text: '• Hybrid funds: Mix stocks and bonds for a balanced approach. Pick a type that aligns with your goals and risk appetite.',
          },
        ],
      },
    ],
    image: 'https://indcdn.indmoney.com/cdn/images/fe/how_to_invest_mf_s2.png',
    bgcolor: 'bg-brand-grey-extraLight',
    headingColor: 'text-gray-700',
  },
  {
    step: 'Step 3',
    stepText: 'Start Investing',
    heading: 'Invest One Time or SIP with as low as ₹100',
    headingType: 'p',
    card_data: [
      {
        type: 'text',
        dataText: [
          {
            text: 'Decide if you want to invest regularly via SIP or make a one-time investment.',
          },
        ],
      },
      {
        type: 'pointers',
        dataText: [
          {
            text: '  • SIPs are great for regular investing and help average out market volatility. You can choose Daily, Weekly, or Monthly SIPs.',
          },
          {
            text: '  • Lumpsum (One time) is ideal when an investor has a significant amount ready to invest for immediate exposure.',
          },
        ],
      },
      {
        type: 'text',
        dataText: [
          {
            text: 'Mutual fund investing is very accessible. You can start investing with as little as ₹100 and get started',
          },
        ],
      },
    ],
    image: 'https://indcdn.indmoney.com/cdn/images/fe/how_to_invest_mf_s3.png',
    bgcolor: 'bg-brand-grey-extraLight',
    headingColor: 'text-gray-700',
  },
]

export const GuideData1: TGuideData = [
  {
    step: 'Step 1',
    stepText: 'Open US a/c',
    heading: 'Open Your Free US Stocks Account on INDmoney',
    headingType: 'p',
    card_data: [
      {
        type: 'text',
        dataText: [
          {
            text: 'Complete your KYC. Make sure you have the following details handy:',
          },
        ],
      },
      {
        type: 'pointers',
        dataText: [{ text: '1. PAN Number' }, { text: '2. Aadhaar Number' }],
      },
      {
        type: 'text',
        dataText: [
          {
            text: 'KYC for the US stocks account is fully digital, paperless, and takes less than 3 minutes to complete.',
          },
        ],
      },
    ],
    image:
      'https://indcdn.indmoney.com/cdn/images/seo/website/18Oct2024USstocksGuidestoinvestStep1.png',
    bgcolor: 'bg-brand-grey-extraLight',
    headingColor: 'text-gray-700',
  },
  {
    step: 'Step 2',
    stepText: 'Add Money',
    heading: 'Add Money to Your US Stocks Wallet',
    headingType: 'p',
    card_data: [
      {
        type: 'text',
        dataText: [
          {
            text: 'To add money to your US stocks account, you will need to link your bank account. This will enable you to digitally exchange your money from Rupees to Dollars and transfer it to your US stocks wallet. You can link any of your bank accounts to the INDmoney app. INDmoney App also works with three preferred banking partners - Federal Bank, HDFC Bank, and Axis Bank - for faster remittances.',
          },
        ],
      },
      {
        type: 'text',
        dataText: [
          {
            text: "Once your bank account is linked, click on the 'Add Money' tab on the US stocks dashboard.",
          },
        ],
      },
      {
        type: 'pointers',
        dataText: [
          { text: 'Enter the amount in rupees that you want to transfer.' },
          {
            text: 'You will see the dollar equivalent amount that will be credited to your US stocks wallet.',
          },
          {
            text: 'You can also check the detailed breakup of the deposit to get a clear view of the best exchange rate and GST charges.',
          },
          { text: 'Confirm the amount and complete the process.' },
        ],
      },
      {
        type: 'text',
        dataText: [
          {
            text: 'Your rupees will be converted into USD and will appear in your US stocks wallet within 24 to 48 hours, subject to banking holidays.',
          },
        ],
      },
    ],
    image:
      'https://indcdn.indmoney.com/cdn/images/seo/website/18Oct2024USstocksGuidestoinvestStep2.png',
    bgcolor: 'bg-brand-grey-extraLight',
    headingColor: 'text-gray-700',
  },
  {
    step: 'Step 3',
    stepText: 'Start Investing',
    heading: 'Start Investing with Just $1',
    headingType: 'p',
    card_data: [
      {
        type: 'text',
        dataText: [
          {
            text: 'Now that your US wallet is funded, you can start investing.',
          },
        ],
      },
      {
        type: 'pointers',
        dataText: [
          {
            text: 'Search for your favorite US stocks or ETFs, or explore various collections and baskets on the app.',
          },
          { text: 'You can instantly buy or sell stocks in just one click.' },
          {
            text: 'With INDmoney, you can start investing in US stocks easily with as little as $1!',
          },
        ],
      },
    ],
    image:
      'https://indcdn.indmoney.com/cdn/images/seo/website/18Oct2024USstocksGuidestoinvestStep4.png',
    bgcolor: 'bg-brand-grey-extraLight',
    headingColor: 'text-gray-700',
  },
]

export const GuideData2: TGuideData = [
  {
    mainHeading: 'How do I place a Buy order for US Stocks?',
    heading: 'Placing a Buy Order for US Stocks',
    subHeading: 'Invest in US stocks with as little as $1!',
    card_data: [
      {
        type: 'animate',
        image:
          'https://indcdn.indmoney.com/cdn/images/seo/website/USstocksGuides18Oct2024Buyorderstep1.png',
        text: 'Instantly Buy',
        aText:
          'Buy US stocks and get them straight to your account in just a few clicks!',
      },
      {
        type: 'animate',
        image:
          'https://indcdn.indmoney.com/cdn/images/seo/website/USstocksGuides18Oct2024Buyorderstep2.png',
        text: 'Place an order in Dollars/INR or in quantities:',
        aText:
          "You can place a buy order using either an amount in dollars/rupees or by selecting a quantity. For example, buy Apple's stock for $5 or ₹500, or select a fraction like 0.5 shares (half a share).",
      },
      {
        type: 'animate',
        image:
          'https://indcdn.indmoney.com/cdn/images/seo/website/USstocksGuides18Oct2024Buyorderstep3.png',
        text: 'Set trigger price:',
        aText:
          "Automate your buy orders by setting a price at which you want to purchase a stock. Just set your target price, and the INDmoney app will execute the buy order when the stock reaches that value. For example, if you want to buy Meta stock at $350, set $350 as your trigger price. When the stock hits that price, the app will automatically buy it for you, even if you're not actively watching the market.",
      },
      {
        type: 'animate',
        image:
          'https://indcdn.indmoney.com/cdn/images/seo/website/USstocksGuides18Oct2024Buyorderstep5.png',
        text: 'Enjoy extended trading hours:',
        aText:
          'Trade in US stocks beyond regular market hours (7 pm to 1:30 am IST) for more flexibility. You can buy and sell US stocks during extended trading hours as per the below-mentioned schedule: Pre-market hours: 1:30 pm - 7:00 pm (IST) After-market hours: 1:20 am - 5:30 am (IST) *These timings are subject to change during daylight savings time adjustment in the US.',
      },
    ],
    image:
      'https://indcdn.indmoney.com/cdn/images/seo/website/USstocksGuides18Oct2024Buyorderstep1.png',
    bgcolor: 'bg-brand-black',
    headingColor: 'text-gray-100',
    headingType: 'h3',
  },
  {
    mainHeading: 'How do I place a Sell order for US Stocks?',
    heading: 'Placing a Sell Order for US Stocks',
    subHeading: 'You can sell a US stock in the following ways:',
    card_data: [
      {
        type: 'animate',
        image:
          'https://indcdn.indmoney.com/cdn/images/seo/website/USstocksGuides18Oct2024sellorderstep1.png',
        text: 'Instantly Sell:',
        aText:
          'Sell your US stocks in just a few clicks and see the proceeds reflect in your account.',
      },
      {
        type: 'animate',
        image:
          'https://indcdn.indmoney.com/cdn/images/seo/website/USstocksGuides18Oct2024sellorderstep2.png',
        text: 'Place a Sell Order in Dollars/INR or in quantities:',
        aText:
          "You can sell by choosing an amount in dollars/rupees or by selecting the number of shares. For example, if you're selling 1 Spotify stock, you can sell it for $500, or for ₹5000 (just an example, not an exact conversion), or you can sell a fraction of the stock, like 0.5 shares if you want to sell half.",
      },
      {
        type: 'animate',
        image:
          'https://indcdn.indmoney.com/cdn/images/seo/website/USstocksGuides18Oct2024sellorderstep3.png',
        text: 'Set trigger price:',
        aText:
          'Set a target price at which you want to sell a stock. The INDmoney app will automatically execute the sale when the stock reaches your set price. For example, if you want to sell Meta stock at $400, set $400 as your trigger price. The app will handle the sale for you once it reaches that price.',
      },
      {
        type: 'animate',
        image:
          'https://indcdn.indmoney.com/cdn/images/seo/website/USstocksGuides18Oct2024sellorderstep4.png',
        text: 'Enjoy extended trading hours:',
        aText:
          'You can sell US stocks outside regular market hours (7 pm to 1:30 am IST) for added flexibility. Trading is available during the following times: Pre-market hours: 1:30 pm - 7:00 pm (IST) *Times may change during US daylight savings adjustments.',
      },
    ],
    image:
      'https://indcdn.indmoney.com/cdn/images/seo/website/USstocksGuides18Oct2024sellorderstep1.png',
    bgcolor: 'bg-brand-black',
    headingColor: 'text-gray-100',
    headingType: 'h3',
  },

  //TODO dont have CDN's for this
  {
    mainHeading: 'How do I withdraw money from my US wallet to my bank a/c?',
    heading:
      'Process for Withdrawing Money from Your US Stocks Wallet to Your Indian Bank Account:',
    card_data: [
      {
        type: 'animate',
        image:
          'https://indcdn.indmoney.com/cdn/images/seo/website/USstocksGuides18Oct2024withdrawalstep1.png',
        text: "Go to the US Stocks' Dashboard:",
      },
      {
        type: 'animate',
        image:
          'https://indcdn.indmoney.com/cdn/images/seo/website/USstocksGuides18Oct2024withdrawalstep2.png',
        text: "Click on the 'Manage' tab",
      },
      {
        type: 'animate',
        image:
          'https://indcdn.indmoney.com/cdn/images/seo/website/USstocksGuides18Oct2024withdrawalstep3.png',
        text: "Choose the 'Withdraw' option. Withdrawals are free if you're using Federal Bank. If not, withdrawal charges are flat $5.",
      },
      {
        type: 'animate',
        image:
          'https://indcdn.indmoney.com/cdn/images/seo/website/USstocksGuides18Oct2024withdrawalstep4.png',
        text: 'Double-check the details and confirm the withdrawal request.',
      },
      {
        type: 'animate',
        image:
          'https://indcdn.indmoney.com/cdn/images/seo/website/USstocksGuides18Oct2024withdrawalstep5.png',
        text: 'Wait for the amount to reach your bank account.',
      },
      {
        type: 'animate',
        image:
          'https://indcdn.indmoney.com/cdn/images/seo/website/USstocksGuides18Oct2024withdrawalstep6.png',
        text: 'The withdrawn amount will be credited to your Indian bank account within 3-5 days.',
      },
    ],
    image:
      'https://indcdn.indmoney.com/cdn/images/seo/website/USstocksGuides18Oct2024withdrawalstep1.png',
    bgcolor: 'bg-brand-black',
    headingColor: 'text-gray-100',
    headingType: 'h3',
  },
]
